export const languages = [{
        name: "PHP"
    },
    {
        name: "Rails"
    },
    {
        name: "Python"
    },
    {
        name: "JavaScript"
    },
    {
        name: "Scala"
    },
    {
        name: "Android"
    },
    {
        name: "iOS"
    },
    {
        name: "Linux"
    },
    {
        name: "Erlang"
    },
];

export const locations = [{
        name: "San Francisco"
    },
    {
        name: "New York City"
    },
    {
        name: "Austin, TX"
    },
    {
        name: "London"
    },
    {
        name: "Europe"
    }
];